import React from "react";
import Box from '@mui/material/Box';
import PropTypes from "prop-types";

const YoutubeEmbed = ({ embedId, showControl, mute }) => (
    <Box sx={{ width: '100%', height: { md: 400 }, backgroundColor: '#f0f0f0' }}>
        <iframe
            title="YouTube Video Player"
            width="100%"
            height="100%"
            src={`https://www.youtube.com/embed/${embedId}?&controls=${showControl}&mute=${mute}&disablekb=1`}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen

        />
    </Box>
);

YoutubeEmbed.propTypes = {
    embedId: PropTypes.string.isRequired
};

export default YoutubeEmbed;
